/* src/app/components/lead-details/participant-information/lead-detail-professional-licenses/lead-detail-professional-licenses.component.css */
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
  cursor: pointer;
}
/*# sourceMappingURL=lead-detail-professional-licenses.component-ZA62GPBR.css.map */
